/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react'
import { useGLTF, useAnimations } from '@react-three/drei'

export function TaurusConstellation({position, rotation, scale, opacity}) {
  const group = useRef()
  const { nodes, materials, animations } = useGLTF('/models/taurus-constellation-dhazele-2.glb')

  return (
    <group ref={group} position={position} rotation={rotation} scale={scale} dispose={null}>
      <group name="Scene">
        <mesh
          name="BezierCurve001"
          castShadow
          receiveShadow
          geometry={nodes.BezierCurve001.geometry}
          position={[0, 0, 0]}
          rotation={[Math.PI / 2, 0, 0]}
        >
          <meshStandardMaterial color='#00ABBC' transparent opacity={opacity}/>
        </mesh>
      </group>
    </group>
  )
}